import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { Logger } from '@app/core/logger.service';
import { JackpotService } from '@app/core/jackpot.service';
import { CryptoPipe } from '@app/shared/pipes/crypto.pipe';
import { CurrencyType } from '@app/core/balance.service';

const logger = new Logger('@app/core:notification.service.ts');

@Injectable()
export class NotificationsService {
  private importantEvents: Array<string> = [
    'email.confirmed',
    'registration.completed',
    'registration.retake',
    'registration.considered',
    'registration.declined',
  ];
  private jackpotEvents: Array<string> = ['jackpot.chest_received', 'reward.received'];
  constructor(
    private http: Http,
    private auth: AuthenticationService,
    private jackpotService: JackpotService,
    private crypte: CryptoPipe
  ) {}

  get() {
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);
    return this.http
      .get('/api/notifications', { headers: headers })
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  amount(amount: number, currency: CurrencyType): string {
    return this.crypte.transform(amount, currency, 'code');
  }

  markAsRead(id: string) {
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);
    return this.http
      .put('/api/notifications/' + id, {}, { headers: headers })
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  textBuilder(event: any): string {
    try {
      switch (event.event) {
        default:
          return event.event;
        case 'state.updated':
          return `Your EDG balance was saved in smart-contract.`;
        case 'deposit.credit':
          return `Deposit of ${this.amount(event.data.amount, event.data.currency)} received.`;
        case 'deposit.first':
          return 'Your first deposit was confirmed on blockchain contract!';
        case 'withdraw.success':
          return `Your withdrawal request of ${this.amount(
            event.data.amount,
            event.data.currency || 'edg'
          )} was completed successfully.`;
        case 'withdraw.aborted':
          return `Your withdrawal request of ${this.amount(
            event.data.amount,
            event.data.currency || 'edg'
          )} was canceled.`;
        case 'withdraw.failed':
          return `Your withdrawal request of ${this.amount(event.data.amount, event.data.currency || 'edg')} failed.`;
        case 'email.confirmed':
          return 'You confirmed your email address!';
        case 'registration.completed':
          return 'Your identity verification is successful!';
        case 'registration.retake':
          return `Verification failed: ${event.data.reason}. Please try with another one!`;
        case 'registration.declined':
          return `Your identity verification verification was declined. ${event.data.reason}`;
        case 'registration.considered':
          return (
            "Our robots wasn't able to read your document. Our verification" +
            ' department will check your case and approve manually . It might take up to 24 hours.'
          );
        case 'jackpot.chest_received':
          return `You have received ${event.data.amount} jackpot chests!`;
        case 'message':
          return event.data.message;
        case 'reward.received':
          return `You got ${event.data.rewardsCount} ${event.data.collectibleName}`;
        case 'bonus.wagered':
          return `You successfully completed wagering ${event.data.bonusName}`;
        case 'cash-back.received':
          return `You have received cash-back of ${this.amount(event.data.amount, event.data.currency || 'edg')}.`;
      }
    } catch (e) {
      return event.event;
    }
  }

  public updateInfo(event: string): void {
    logger.info(`Got new ${event} event!`);
    if (this.importantEvents.includes(event)) {
      logger.info(`Event wants to update information!`);
      this.auth.getUserInfo().subscribe(() => {}, () => {});
    }
    if (this.jackpotEvents.includes(event)) {
      logger.info(`Event wants to update information!`);
      this.jackpotService.getAuthInfo();
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/notifications.service.ts